import api from "../api/api";

const normalizeOffersResponse = (response) => {
  if (!response?.data) return [];
  if (Array.isArray(response.data)) return response.data;
  if (Array.isArray(response.data.data)) return response.data.data;
  return [];
};

export const OfferServices = {
  getAllOffers: async () => {
    const res = await api.get("/offers");
    return normalizeOffersResponse(res);
  },

  getOfferById: async (id) => {
    if (!id) throw new Error("Offer ID is required");
    const res = await api.get(`/offers/${id}`);

    if (res?.data?.status && res.data.data) {
      return res.data.data;
    }

    return res?.data || null;
  },
};